import type { NewTicketPopupPrefillI } from 'contexts/TicketsContext';
import type { WipRecordI } from 'declarations/interfaces/wip';

/**
 * Maps a WIP record to the prefill payload accepted by the New Ticket popup. Mirrors WarrQueue's
 * `mapWipToDisplay` + `defaultAmount` logic, adapted for the dealer-side popup: the same fields
 * (RO #, line, open date, advisor, tech, dealer) carry over and the popup amount defaults to the
 * WIP record's claim total when available, matching WarrQueue's `wipRecord.claimTotal ?? 0`.
 */
export const mapWipRecordToChirpTicketPrefill = (
  wipRecord: WipRecordI
): NewTicketPopupPrefillI => ({
  roofTopId: wipRecord.roofTopId || undefined,
  roNumber: wipRecord.repairOrderNumber || undefined,
  lineNumber: wipRecord.lineNumber ?? undefined,
  roDate: wipRecord.openRepairOrderDate ?? null,
  advisorNumber: wipRecord.advisorNumber ?? undefined,
  techNumber: wipRecord.techNumber ?? undefined,
  amount: wipRecord.claimTotal ?? 0,
});
